import hdrm from '../../hdrm';
import actionTypes from '../constants/action-types';
import globals from '../../globals';
import { UPDATE_BOTH, UPDATE_STATIC_ONLY } from '../../hdrm/constants/update-strategies';
import DEFAULT_OPTIONS from '../constants/default-options';

const cutElement = (elementId, initialOptions = {}) => {
  const calculatedStrategy = hdrm.verifiers.hasElementAdditives(elementId)
    ? UPDATE_STATIC_ONLY
    : UPDATE_BOTH;

  const options = {
    ...DEFAULT_OPTIONS,
    ...initialOptions,
    strategy: initialOptions.strategy || calculatedStrategy,
  };

  return globals.helpers.globalActionExtender({
    type: actionTypes.CUT_ELEMENT,
    payload: {
      elementId,
      options,
    },
  });
};

export default cutElement;
